import { useMemo } from 'react'
import parse from 'html-react-parser'
import Head from 'next/head'

import { useStore } from '@/contexts/store'
import { FRONT_BASE_URL } from '@/constants'

import { WPPageData } from '@/types'

export type MetaProps = {
  pageData: WPPageData
}

const Meta = ({ pageData }: MetaProps) => {
  const { meta } = useStore()
  const { template, yoast_head } = pageData

  const metadata = useMemo(
    () => ({ ...meta![template], ...meta?.shared }),
    [template, meta]
  )

  return (
    <Head>
      {parse(yoast_head?.replace(/"\//g, `"${FRONT_BASE_URL}/`) || '')}
      <title>{metadata.title}</title>
      <meta name="description" content={metadata.description} />
      <meta property="og:locale" content={metadata.og_locale} />
      <meta property="og:type" content={metadata.og_type} />
      <meta property="og:title" content={metadata.title} />
      <meta property="og:description" content={metadata.description} />
      <meta property="og:url" content={FRONT_BASE_URL} />
      <meta
        property="og:image"
        content={`${FRONT_BASE_URL}/${metadata.og_image}`}
      />
      <meta property="og:site_name" content={metadata.og_site_name} />
      <meta name="twitter:card" content={metadata.twitter_card} />
    </Head>
  )
}

export default Meta
